import { createTypedSelector } from "../common/root-reducer-selector";
import { RootState } from "../types";

export const chatSelector = createTypedSelector(
  (state) => state,
  (state: RootState) => state.chat
);

export const inputCollectionSelector = createTypedSelector(
  (state) => state,
  (state: RootState) => state.chat.inputCollection
);

export const feedbackFormSelector = createTypedSelector(
  (state) => state,
  (state: RootState) => state.chat.getFeedback
);

export const requireFeedbackIndex = createTypedSelector(
  (state) => state,
  (state: RootState) => {
    let userMessageCount = 0;

    for (let i = 0; i < state.chat.messages.length; i++) {
      if (state.chat.messages[i].itemType === 'U') {
        userMessageCount++;
      }

      if (userMessageCount >= state.theme.themeConfig.requireFeedbackAfterUserTurn) {
        return i;
      }
    }

    // if something wend wrong show feedback for all bot messages
    return 0;
  }
)